import { RefObject, useCallback } from 'react';
import Webcam from 'react-webcam';

const useCapture = (webcamRef: RefObject<Webcam | null>, onCapture: (image: string) => void, onClose: () => void) => {
  return useCallback(() => {
    const video = webcamRef.current?.video;
    if (!video) return;

    const canvas = document.createElement('canvas');
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
    const imageSrc = canvas.toDataURL('image/jpeg', 1);

    if (imageSrc) {
      onCapture(imageSrc);
      onClose();
    }
  }, [webcamRef, onCapture, onClose]);
};

export default useCapture;